// This shim replaces nativewind in web builds via Vite resolve alias.
//
// Why: nativewind/dist/index.js is CJS and unconditionally requires ./doctor.js
// (from react-native-css-interop). vite-plugin-react-native-web runs with enforce: 'pre'
// and transforms ALL .js files through esbuild before Rollup's @rollup/plugin-commonjs
// can detect and wrap them. This causes raw CJS `exports` references to survive into the
// production ESM bundle, where `exports` is undefined — crashing the app at runtime.
//
// The shim sidesteps this by resolving nativewind to pure ESM, eliminating the CJS chain.
// On web, cssInterop is a no-op because DOM elements support className natively.

export const cssInterop = (component) => component;

export const remapProps = cssInterop;
